'use client';

import { useEffect, useLayoutEffect, useState } from 'react';
import { GlobalDataContext } from './context';
import { customApi } from '@/api/api';
import { usePathname, useRouter } from 'next/navigation';
import useUserData from '@/zustand/user';

export default function GlobalProvider({ children }) {
  const router = useRouter();
  const pathname = usePathname();
  const { user, deleteUser } = useUserData();
  const [userData, setUserData] = useState(null);

  useLayoutEffect(() => {
    if (!userData) return;
    if (pathname === '/login') return;
    if (!localStorage.getItem('aidoo_token')) return;

    // 관리자
    if(userData.type === 1) return

    const managerPath = ['/myCompany', '/firstLogin'];
    const studentPath = ['/myClass', '/firstLogin'];
    const salesPath = ['/sales', '/firstLogin'];
    const eduMasterPath = ['/eduMaster', '/firstLogin'];

    if (userData.type === 6) {
      // 교육생
      if (!studentPath.includes(pathname)) {
        alert('접근 권한이 없습니다.');
        localStorage.removeItem('aidoo_token');
        router.replace('/login');
      }
    } else if (userData.type === 2) {
      // 영업자
      if (!salesPath.includes(pathname)) {
        alert('접근 권한이 없습니다.');
        localStorage.removeItem('aidoo_token');
        router.replace('/login');
      }
    } else if (userData.type === 3) {
      // 사업체 (사업자번호 로그인)
      if (!managerPath.includes(pathname)) {
        alert('접근 권한이 없습니다.');
        localStorage.removeItem('aidoo_token');
        router.replace('/login');
      }
    } else if (userData.type === 4) {
      if (!eduMasterPath.includes(pathname)) {
        alert('접근 권한이 없습니다.');
        localStorage.removeItem('aidoo_token');
        router.replace('/login');
      }
    } else {
      alert('접근 권한이 없습니다.');
      localStorage.removeItem('aidoo_token');
      router.replace('/login');
    }
  }, [userData, pathname]);

  const getUserData = async () => {
    try {
      const noAuthPaths = ['/', '/login', '/firstLogin', '/question', '/result'];

      if (noAuthPaths.includes(pathname)) {
        return;
      }

      if (pathname.startsWith('/cyber')) return
      if (pathname.startsWith('/company02')) return;

      const res = await customApi({ method: 'GET', url: '/ping', isToken: true });
      if (res.success) {
        setUserData(res.data);
      } else {
        alert(res.message);
        localStorage.removeItem('aidoo_token');
        router.replace('login');
      }
    } catch (error) {
      alert(error.message);
      localStorage.removeItem('aidoo_token');
      router.replace('login');
    }

    deleteUser();
  };

  useEffect(() => {
    getUserData();

    /* 뒤로가기 감지 */
    const handlePopState = () => {
      getUserData();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [pathname]);

  const deleteUserData = () => {
    setUserData(null);
  };

  // 카카오 지도
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return <GlobalDataContext.Provider value={{ userData, getUserData, deleteUserData }}>{children}</GlobalDataContext.Provider>;
}
